import React from 'react';

import Switch from 'components/fields/Switch';
import { RewardBenefitDto, RewardLevelDto } from '../../types';

interface SwitchFieldProps {
  benefit: RewardBenefitDto;
  levelId?: RewardLevelDto['id'];
  loading?: boolean;
  onToggle: (benefit: RewardBenefitDto, levelId?: RewardLevelDto['id']) => void;
}

const SwitchField = ({ benefit, levelId, loading, onToggle }: SwitchFieldProps) => (
  <Switch
    checked={Boolean(benefit?.levels?.includes(levelId))}
    onChange={() => onToggle(benefit, levelId)}
    color="primary"
    disabled={!benefit?.id || !levelId || loading}
  />
);

export default SwitchField;
